import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_STATUSTEMPLATE] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.statusTemplate = payload
  },
  [types.SET_STATUSTEMPLATES] (state, payload) {
    state.statusTemplates = payload.data
    state.pagination = { total: payload.total, current_page: payload.current_page }
  }
}
